<template>
  <div class="p-notfound">
    <div>
      <div class="p-notfound__hgroup">
        <h2 class="p-notfound__heading">404</h2>
        <p class="p-notfound__subheading">Not Found</p>
      </div>
      <p class="p-notfound__lead">The page you were looking for could not be found. <br>Please search again from the TOP.</p>
      <div class="p-buttonContainer" data-align="center">
        <transition-button 
          to="/" 
          type="back" 
          class="p-notfound__button">Back to TOP
        </transition-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex'
  import TransitionButton from '~/partial/transition-button.vue'

  export default {
    name: 'page-notfound',
    components: {
      TransitionButton
    },
    data () {
      return {
      }
    },
    beforeRouteLeave(to, from, next) {
      this.showLoader()

      next()
    },
    created() {
    },
    mounted() {
      this.$nextTick(() => {
        this.hideLoader()
      })
    },
    methods: {
      ...mapMutations({
        'showLoader': 'loader/SHOW',
        'hideLoader': 'loader/HIDE',
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/not_found.vue